import { I18n, Translate } from "react-redux-i18n";
import { CAMPAIGN_STATUS } from "assets/js/const/Campaign";
import { getCalendarFormat } from "utils/dateTimeUtils";
import fetchRoute from "utils/routes";
import React from "react";

const sortAlphabetically = (arr, order) => {
	if (arr) {
		return arr.sort(function (a, b) {
			var textA = a.name.toUpperCase();
			var textB = b.name.toUpperCase();
			return textA < textB ? -1 : textA > textB ? 1 : 0;
		});
	}
	return arr;
};

const getCampaignProgress = (
	campaign,
	date,
	unBlockedDomains,
	scheduleDataValid,
	totalSteps = 6
) => {
	if (campaign) {
		let total = 0;

		if (campaign.status !== CAMPAIGN_STATUS.INCOMPLETE) return 100;

		if (campaign.audience.list_id) total++;
		//if (campaign.name && campaign.name !== I18n.t("app-campaigns-flow-step1-subject-untitled" )) total++;
		if (campaign.sender.email) total++;
		if (
			campaign.sender.name &&
			campaign.sender.name !==
				I18n._translate("app-campaign-steps-overview-sender_unknown")
		) {
			const senderDomain = campaign.sender.email.substring(
				campaign.sender.email.indexOf("@") + 1
			);
			if (unBlockedDomains)
				if (unBlockedDomains.filter((d) => senderDomain == d).length > 0) {
					total++;
				}
		}
		if (
			campaign.content.subject &&
			campaign.content.subject !==
				I18n._translate("app-campaign-steps-overview-subject_empty")
		)
			total++;
		if (campaign.content.html || campaign.content.json) total++;
		if (date && scheduleDataValid) total++;

		return (total * 100) / totalSteps;
	} else {
		return 0;
	}
};

function getSegmentIdFromName(segment) {
	if (segment && segment.includes("multisublist_")) {
		let ids = segment.split("_");
		ids.splice(0, 2);
		ids.pop();
		ids = ids.map((id) => {
			if (isNaN(id)) {
				return id;
			}
			return parseInt(id);
		});
		return ids;
	}
	return [];
}

function getCampaignListingInfoStructure(
	campaign,
	campaignReport,
	campaignSegment,
	campaignList,
	customDateObject = null
) {
	let segmentIds = [];
	let segmentElement = null;
	if (campaignSegment?.name) {
		segmentIds = getSegmentIdFromName(campaignSegment?.name);

		if (segmentIds.length > 0) {
			segmentElement = (
				<>
					{segmentIds.length}{" "}
					<Translate className={"test"} value={"app-general-segment-plurial"} />
				</>
			);
		} else {
			segmentElement = (
				<>
					1 <Translate value="app-general-segment" />
				</>
			);
		}
	}

	return (
		<>
			{customDateObject ? (
				customDateObject
			) : (
				<>
					{campaign?.status !== "incomplete" ? (
						<Translate value="app-general-sent" />
					) : (
						<Translate value="app-general-date-created" />
					)}{" "}
					{getCalendarFormat(
						campaign.scheduled_for
							? campaign.scheduled_for
							: campaign.created_on
					)}
				</>
			)}{" "}
			{campaignReport?.sent_emails && (
				<>
					<Translate value="app-general-to" /> {campaignReport?.sent_emails}{" "}
					{campaignReport?.sent_emails > 1 ? (
						<Translate value="app-campaigns-flow-overview-to-subscribers" />
					) : (
						<Translate value="app-campaigns-flow-overview-to-subscriber" />
					)}
				</>
			)}
			<br />
			<span className="line">
				<a
					className={segmentElement ? "list" : ""}
					href={`#${fetchRoute("contacts")}?listId=${
						campaign.audience.list_id
					}`}
				>
					{campaign.audience?.name
						? campaign.audience.name
						: campaignList?.name}
				</a>{" "}
				{""}
				{segmentElement}
			</span>
		</>
	);
}

function loadImage(url) {
	return new Promise((resolve, reject) => {
		let img = document.createElement("img");
		img.src = url;
		img.onload = () => {
			resolve();
		};
		img.onerror = () => {
			reject();
		};
	});
}

export function base64Encode(s) {
	const trimmedString = s.trim();
	return btoa(trimmedString);
}

export function base64Decode(s) {
	return atob(s);
}

export function isBase64Encoded(str) {
	const base64Regex =
		/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
	return base64Regex.test(str);
}

export function replaceInvalidInterestChar(value) {
	return value.replace(/[^A-Za-z0-9\-+_@]+/g, "_");
}

export {
	loadImage,
	sortAlphabetically,
	getCampaignProgress,
	getSegmentIdFromName,
	getCampaignListingInfoStructure,
};
